import React from 'react';
import SearchBar from './components/SearchBar/SearchBar';
import UsersList from './components/UsersList/UsersList';
// Note: Group view is not implemented in legacy version. So this is commented out.
// import GroupsSelection from './components/GroupsSelection/GroupsSelection';
// import GroupsSelectionSummary from './components/GroupsSelectionSummary/GroupsSelectionSummary';
import {
  STUDENTS_VIEW,
  NavigationView as NavigationViewType,
} from './components/Navigation/constants';
import { SpaceUser, SpaceGroup } from './Conversion.types';
import { CREATING_EXTENSION_SERVER_ERROR } from '../../Assignments/constants';
import { Box, Alert, Icons } from '@ublend-npm/aulaui-core';
import { REMOVE_FROM_EXTENSION_TOOLTIP } from './constants';

const errorText = CREATING_EXTENSION_SERVER_ERROR;
const USER_ACTION_DISABLED = 'Student submission exists in this assignment.';

const filterOutSelectedStudentsFromUnassigned = (
  unassignedStudents,
  assignedStudents
) =>
  unassignedStudents.reduce((acc, user) => {
    if (assignedStudents.some((student) => student.id === user.id)) {
      return acc;
    }
    return [...acc, user];
  }, []);

type NavigationViewProps = {
  spaceGroups: SpaceGroup[];
  data: {
    assignedStudents: SpaceUser[];
    unassignedStudents: SpaceUser[];
    groups: any;
  };
  setData: (newProps: any) => void;
  navigationView: NavigationViewType;
  hasError?: boolean;
  isLoadingStudents?: boolean;
  greyedOutUsers?: string[];
};

const NavigationView = ({
  data: { assignedStudents, groups, unassignedStudents },
  setData,
  spaceGroups,
  navigationView,
  hasError = false,
  greyedOutUsers = [],
  isLoadingStudents = false,
}: NavigationViewProps) => {
  return (
    <>
      {navigationView === STUDENTS_VIEW && (
        <>
          <SearchBar
            users={unassignedStudents}
            selectedUsers={assignedStudents}
            greyedOutUsers={greyedOutUsers}
            isFetching={isLoadingStudents}
            onChange={(selectedStudents) => {
              const updatedUnassignedStudents =
                filterOutSelectedStudentsFromUnassigned(
                  unassignedStudents,
                  selectedStudents
                );
              setData({
                assignedStudents: selectedStudents,
                unassignedStudents: updatedUnassignedStudents,
              });
            }}
          />
          {/* Error alert */}
          {hasError && (
            <Box sx={{ mt: 1 }}>
              <Alert severity="error">{errorText}</Alert>
            </Box>
          )}
          <UsersList
            users={assignedStudents}
            onActionClick={(studentToUnassign) => {
              const { id } = studentToUnassign;

              const isStudentUnassigned = unassignedStudents.some(
                (student) => student.id === id
              );

              setData({
                unassignedStudents: isStudentUnassigned
                  ? unassignedStudents
                  : [...unassignedStudents, studentToUnassign],
                assignedStudents: assignedStudents.filter(
                  (student) => student.id !== id
                ),
              });
            }}
            actionIcon={Icons.RemoveCircle}
            disabledText={USER_ACTION_DISABLED}
            tooltip={REMOVE_FROM_EXTENSION_TOOLTIP}
          />
        </>
      )}
      {/* Note: Group view is not implemented in legacy version. So this is commented out. */}
      {/* {navigationView === GROUP_VIEW && (
        <>
          <GroupsSelection
            selectedGroups={groups}
            spaceGroups={spaceGroups}
            onChange={(e) =>
              setData({
                groups: e.target.value,
              })
            }
          />
          <GroupsSelectionSummary students={groups.students} />
        </>
      )} */}
    </>
  );
};

export default React.memo(NavigationView);
